module.exports = __webpack_public_path__ + "static/primary-white-639cfcce0deb6179b40239479cb4c799.png";